import { render, staticRenderFns } from "./TopbarDefault.vue?vue&type=template&id=70c77beb"
import script from "./TopbarDefault.vue?vue&type=script&lang=js"
export * from "./TopbarDefault.vue?vue&type=script&lang=js"
import style0 from "./TopbarDefault.vue?vue&type=style&index=0&id=70c77beb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports